import requestAction from '../../utils/requestAction'

export const fetchDeliveryLocations = (params: string) =>
  requestAction('DELIVERY_LOCATION_LIST', params)(`deliveryLocations`, 'GET')
